export const SoldLabel = () => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 300.000000 169.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <metadata>
                Created by potrace 1.10, written by Peter Selinger 2001-2011
            </metadata>
            <g
                transform="translate(0.000000,169.000000) scale(0.050000,-0.050000)"
                fill="currentColor"
                stroke="none"
            >
                <path
                    d="M4140 2937 c-27 -12 -63 -24 -80 -27 -40 -6 -385 -97 -1510 -399
-517 -139 -1043 -280 -1170 -313 -814 -213 -824 -240 -516 -1338 94 -338 132
-420 221 -486 171 -128 212 -128 735 7 433 112 500 136 520 186 15 37 18 38
19 6 1 -47 40 -41 417 68 151 44 299 84 329 88 72 12 275 70 318 92 18 9 50
12 72 6 52 -13 74 21 35 53 -17 14 -30 37 -30 52 0 34 -20 35 -94 5 -77 -32
-83 -33 -195 -57 -55 -11 -108 -29 -119 -40 -11 -11 -49 -20 -85 -20 -45 0
-76 -15 -106 -53 -37 -48 -41 -49 -41 -12 0 40 -3 40 -95 12 -52 -15 -129 -37
-170 -48 -43 -12 -75 -33 -75 -50 0 -32 -51 -40 -69 -10 -7 11 -41 7 -82 -11
-39 -16 -79 -24 -89 -18 -10 6 -34 2 -54 -9 -20 -11 -90 -33 -156 -49 -66 -15
-248 -60 -405 -100 -501 -127 -533 -109 -675 380 -252 861 -247 1055 27 1121
29 7 404 107 833 222 429 115 951 254 1160 308 209 54 575 153 813 218 475
131 553 140 657 76 119 -72 122 -79 289 -705 49 -185 102 -352 118 -370 31
-35 13 -202 -34 -302 -29 -63 -220 -159 -416 -209 -81 -20 -169 -47 -197 -58
-27 -11 -63 -21 -80 -22 -122 -7 -436 -107 -460 -148 -15 -26 -23 -28 -37 -7
-28 43 -127 8 -119 -41 12 -80 59 -84 248 -24 98 31 181 63 184 71 4 9 20 11
35 5 16 -6 29 0 29 13 0 14 13 19 31 12 39 -15 292 45 319 76 11 12 45 19 76
16 111 -13 434 127 434 188 0 15 13 28 28 28 49 0 78 134 66 298 -13 171 -228
978 -300 1122 -87 177 -372 279 -554 197z"
                />
                <path
                    d="M3833 2564 c-32 -51 31 -197 92 -215 176 -52 336 -684 209 -824 -34
-38 -37 -52 -17 -96 13 -28 23 -68 23 -90 0 -24 14 -39 36 -39 51 0 224 113
224 146 0 16 15 57 32 93 38 75 31 166 -36 466 -27 122 -53 195 -69 195 -14 0
-21 12 -15 28 13 35 -69 212 -105 226 -15 6 -27 23 -27 38 0 63 -312 129 -347
72z m467 -724 c0 -22 -12 -40 -26 -40 -14 0 -27 18 -29 40 -1 23 10 40 26 40
16 0 29 -18 29 -40z"
                />
                <path
                    d="M3652 2524 c-6 -10 -47 -25 -92 -32 -44 -7 -80 -17 -80 -22 0 -15
100 -357 113 -390 8 -16 12 -38 9 -47 -2 -10 14 -73 36 -140 23 -68 72 -244
111 -391 83 -318 75 -308 201 -265 125 41 127 6 -40 643 -170 650 -203 732
-258 644z m24 -341 c4 -23 -2 -43 -12 -43 -31 0 -69 56 -54 80 21 34 59 12 66
-37z"
                />
                <path
                    d="M2940 2337 c-105 -30 -110 -43 -75 -171 18 -64 73 -269 123 -456 195
-729 178 -681 233 -673 114 16 184 60 171 108 -57 193 -135 494 -139 536 -4
29 -13 63 -21 76 -9 14 -36 117 -62 229 -93 413 -80 393 -230 351z"
                />
                <path
                    d="M2340 2173 c0 -55 61 -198 110 -260 28 -35 58 -73 68 -85 10 -12 24
-61 32 -110 8 -48 36 -160 62 -248 26 -88 47 -188 48 -223 0 -34 13 -73 30
-87 16 -13 24 -33 18 -43 -7 -11 -22 -10 -37 3 -20 15 -29 13 -38 -9 -14 -37
4 -91 30 -91 10 0 13 -21 6 -46 -35 -140 136 -80 209 73 65 132 45 275 -109
805 -48 166 -161 301 -284 337 -33 10 -45 6 -45 -18 0 -17 -9 -31 -19 -31 -11
0 -15 14 -8 30 8 21 -2 30 -31 30 -23 0 -42 -12 -42 -27z"
                />
                <path
                    d="M2128 2089 c-116 -122 -134 -265 -66 -521 23 -87 53 -203 67 -258 80
-311 283 -524 441 -463 51 20 3 167 -106 323 -36 52 -75 161 -112 310 -31 127
-69 254 -84 283 -23 46 -23 62 3 110 28 53 26 145 -4 252 -15 55 -66 42 -139
-36z m116 -528 c-10 -71 -33 -78 -65 -19 -18 33 -15 46 14 68 49 36 62 23 51
-49z m240 -545 c-11 -11 -41 -16 -67 -11 l-47 8 50 21 c55 24 94 12 64 -18z"
                />
                <path
                    d="M1511 1958 c-15 -39 30 -155 89 -234 27 -37 50 -82 50 -100 0 -38 34
-39 157 -7 102 26 102 27 65 136 -56 163 -321 314 -361 205z"
                />
                <path
                    d="M1284 1845 c-88 -94 -88 -96 -79 -216 15 -187 168 -409 283 -409 12
0 66 -23 120 -50 55 -28 115 -50 134 -50 44 0 86 -119 73 -207 -25 -162 45
-291 115 -213 20 22 47 40 60 40 13 0 35 25 49 55 134 284 -4 508 -409 665
-165 64 -190 119 -189 425 0 83 -55 69 -157 -40z m72 -285 c1 -54 -2 -57 -29
-30 -17 17 -26 44 -20 61 20 49 47 32 49 -31z"
                />
                <path
                    d="M3525 1365 c-102 -30 -140 -81 -85 -115 11 -7 20 -40 20 -74 0 -60 1
-61 83 -48 154 25 180 65 139 211 -17 61 -29 63 -157 26z"
                />
                <path
                    d="M1440 1012 c-165 -59 -23 -354 184 -383 157 -21 184 92 56 238 -31
36 -63 89 -71 119 -15 61 -55 67 -169 26z"
                />
            </g>
        </svg>
    )
}
